import React from 'react';

import { observer } from 'mobx-react';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { SectionBanner, Paragraph, Box } from 'components';
import Projects from 'apps/projects';
import { useNoAuthRedirect, useClientStore } from 'apps/hooks';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';
import DocumentHead from 'legacyComponents/documentHead';

const ProjectsPage = observer(() => {
  const clientStore = useClientStore();
  const { isMobile, activeSpace } = clientStore;

  useNoAuthRedirect();

  const title =
    activeSpace?.spaceType === 'INITIATIVE'
      ? `${activeSpace?.content?.title}'s Projects`
      : 'My Projects';

  return (
    <MainWrapper marginBottom='4em'>
      <DocumentHead title={title} />
      {!isMobile && (
        <SectionBanner
          bannerId='projects-design'
          imageSrc='/assets/banners/005.svg'
          title='Move your designs forward in an agile way with Projects'
          buttonText='Start a Project'
          linkName='https://wikifactory.com/new-project'
          paddingTop='large'
          paddingBottom='xlarge'
          eventCallback={() => analytics.sendEvent(BANNER_ACTIONS.PROJECTS)}
        >
          <Box>
            <Paragraph>
              Your <strong>single source of truth</strong> for all your product
              files, data, and documentation.
            </Paragraph>
            <Paragraph>
              Intuitive <strong>version control</strong> allows you to track
              every change and design decision – with total certainty.
            </Paragraph>
            <Paragraph>
              With our CAD Rooms built in,{' '}
              <strong>
                visualize over 30 CAD formats online on desktop, tablet,
              </strong>{' '}
              and mobile. You never have to ask, “is this the latest again?”.
            </Paragraph>
          </Box>
        </SectionBanner>
      )}
      <Projects />
    </MainWrapper>
  );
});

export default ProjectsPage;
